import React, { useEffect, useState } from "react";
import {Table, Row, Col, Card, CardBody, Modal, CardTitle, ModalHeader, ModalBody, FormGroup, Label, InputGroup, Button} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import * as url from "../../helpers/url_helper"
import moment from "moment";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { PhoneInput } from 'react-international-phone';
import { json, Link } from "react-router-dom";
const Pays = () => {
  document.title = "AMAVIE | Gestion de la tarification";
  const [countries, setCountries]= useState([])
  const [search, setSearch]= useState("")
  const removeBodyCss = () => { document.body.classList.add("no_padding"); };

    const loadCountries=(search)=> {
        fetch(`${url.BACKEND_URL}/countries?search=${search}`, {
          method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
        .then((response) => response.json())
        .then((responseJson) => { 
          if (responseJson.status==200) { setCountries(responseJson.data) }
        }) .catch((error) => {  });
      };
  useEffect(()=>{ loadCountries("") }, [])
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="AMAVIE" title="Pays" />
          
          <Row>
            <CardTitle className="h4">Liste des pays</CardTitle>
            <Col md={4}>
              <div className="mb-3">
                <Label>Recherche</Label>
                <input className="form-control" placeholder="Rechercher" onChange={(event)=>{loadCountries(event.target.value), setSearch(event.target.value)}} type="text" defaultValue="" id="example-datetime-local-input"/>
              </div>
            </Col>
            <Col md={2}>
              <div className="mb-3">
                <Label style={{ visibility: "hidden" }}>--</Label>
                <Button color="primary" className="form-control btn btn-primary waves-effect waves-light" onClick={()=>loadCountries(search)}><i className="fas fa-search"></i> Rechercher</Button>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  {/* <p className="card-title-desc">
                    Use one of two modifier className to make{" "}
                    <code>&lt;thead&gt;</code>s appear light or dark gray.
                  </p> */}

                {/*MODAL POUR VISUALISER L'ATTESTATION*/}
                  <div className="table-responsive">
                    <Table className="table mb-0" style={{fontSize: 16}}>
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Nom</th>
                          <th>Préfixe</th>
                          {/* <th>Détails</th> */}
                        </tr>
                      </thead>
                      <tbody>
                         {countries.map((item, key)=>(
                            <tr>
                              <td>{item?.id}</td>
                              <td>{item?.name}</td>
                              <td> {item?.prefix}</td>
                              {/* <td><a className="fas fa-book" onClick={()=>{setTimeout(() => { tog_detail_tarification(item)}, 400);}}></a></td> */}
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Pays;
